export interface AppCoachDashboardRootPostsFormUpdate {
  id: string;
  user_id: string;
  organization_id: string;
  user: {
    id: string;
    content: {
      name: string;
      surname: string;
    };
  };
  content: {
    roles: string;
    message: string;
    url: string;
  };
}

export class AppCoachDashboardRootPostsFormUpdate implements AppCoachDashboardRootPostsFormUpdate {
  id: string;
  user_id: string;
  organization_id: string;
  user: {
    id: string;
    content: {
      name: string;
      surname: string;
    };
  };
  content: {
    roles: string;
    message: string;
    url: string;
  };

  constructor() {
    this.id = "";
    this.user_id = "";
    this.organization_id = "";
    this.user = {
      id: "",
      content: {
        name: "",
        surname: "",
      },
    };
    this.content = {
      roles: "",
      message: "",
      url: "",
    };
  }
}